import callModal from './callModal.html'
import recordingPlayer from './recordingPlayer.html'
import computerMode from './computerMode.html'
import phoneMode from './phoneMode.html'

export {
  callModal,
  recordingPlayer,
  computerMode,
  phoneMode
}